export class BreakpointTypes {
  static x =  1600;
  static l = 1200;
  static m = 1024;
  static s = 768;
  static xs = 400;
}
